export const SITE_URL = "fashionth.maximquiz.com";
